import {deprecatedFetchProfiles} from "@/data/DeprecatedBeefCache";
import _ from 'underscore';
import {getProfileIcon} from "@/app/utils/Profiles";
import {currentAccountCode} from "@/app/utils/Account";
import {getProfileDisplayName} from "@/setup/profiles/ProfileUtils";
import {createTagConverter, toPlaceholderHTML} from "@/app/framework/pickers/picker-utils";
import {splitUnique} from "@/app/utils/StringUtils";
import VuexStore from "@/store/vuex/VuexStore";

Beef.module("ProfilePicker").addInitializer(function(startupOptions) {

    this.View = Backbone.Marionette.Layout.extend({
        template: require("@/dashboards/filter/pickers/profile/ProfilePicker.handlebars"),

        attributes: { class: "profile-picker dialog" },

        regions: {
            listRegion: '.profile-list'
        },

        events: {
            "mousedown": "mousedown",
            "click .profile-select-all": "selectAll",
            "click .profile-deselect-all": "deselectAll",
            "click .profile-select-twitter": "selectTwitter",
            "click .profile-select-facebook": "selectFacebook",
            "click .profile-select-instagram": "selectInstagram",
            "click .profile-select-facebook-competitor": "selectFacebookCompetitors",
            "click .profile-select-facebook-own": "selectFacebookOwnProfiles",
            "click .profile-select-instagram-competitor": "selectInstagramCompetitors",
            "click .profile-select-instagram-own": "selectInstagramOwnProfiles",
            "click .profile-select-linkedin-competitor": "selectLinkedInCompetitors",
            "click .profile-select-linkedin-own": "selectLinkedInOwnProfiles",
            "click .profile-select-tiktok-competitor": "selectTikTokCompetitors",
            "click .profile-select-tiktok-own": "selectTikTokOwnProfiles",
            "click .profile-select-youtube-competitor": "selectYouTubeCompetitors",
            "click .profile-select-youtube-own": "selectYouTubeOwnProfiles",
            "click .profile-select-twitter-competitor": "selectTwitterCompetitors",
            "click .profile-select-twitter-own": "selectTwitterOwnProfiles",
            "click .close": "close"
        },

        templateHelpers: function() {
            // flags for disabling 'select all' buttons for different profile types
            var disabled = this.options.disabled ? this.options.disabled : {};
            const accountCode = currentAccountCode();
            return {
                title: this.options.title,
                disabled: disabled,
                isAljAccount: accountCode === "BEAL65AA" || accountCode === "BECH69AA",
            }
        },
        //-----------------------------------

        mousedown: function(ev) {
            ev.preventDefault();    // this stops stuff on the picker from getting focus
        },

        selectAll: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;

            _(this.list.collection.models).each(function (m) {
                m.setSelected(true);
            });
            this.handleCollectionChange();
        },

        deselectAll: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne')) return;

            _(this.list.collection.models).each(function (m) {
                m.setSelected(false);
            });
            this.handleCollectionChange();
        },

        selectTwitter: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;

            _(this.list.collection.models).each(function (m) {
                switch (m.get('type')) {
                    case "TWITTER_SCREEN_NAME":
                        m.setSelected(true); break;
                    case "FACEBOOK_PAGE":
                    case "FACEBOOK_USER":
                    default:
                        m.setSelected(false);
                }
            });
            this.handleCollectionChange();
        },

        selectFacebook: function(ev) {
            ev.preventDefault();
                if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;
            const accountCode = currentAccountCode();

            if (accountCode === "BEAL65AA" || accountCode === "BECH69AA") {
                this.filterCompetitorsByChannel(
                    [... this.getOwnProfiles(), ... this.getCompetitors()], "facebook");
            } else {
                _(this.list.collection.models).each(function (m) {
                    switch (m.get('type')) {
                        case "FACEBOOK_PAGE":
                        case "FACEBOOK_USER":
                            m.setSelected(true); break;
                        case "TWITTER_SCREEN_NAME":
                        default:
                            m.setSelected(false);
                    }
                });
            }
            this.handleCollectionChange();
        },

        selectInstagram: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;

            const accountCode = currentAccountCode();

            if (accountCode === "BEAL65AA") {
                this.filterCompetitorsByChannel(
                    [... this.getOwnProfiles(), ... this.getCompetitors()], "instagram");
            } else {
                _(this.list.collection.models).each(function (m) {
                    switch (m.get('type')) {
                        case "INSTAGRAM_USER":
                        case "INSTAGRAM_BUSINESS":
                            m.setSelected(true); break;
                        default:
                            m.setSelected(false);
                    }
                });

            }

            this.handleCollectionChange();
        },

        selectFacebookCompetitors: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;

            this.filterCompetitorsByChannel(this.getCompetitors(), "facebook");
            this.handleCollectionChange();
        },

        selectInstagramCompetitors: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;

            this.filterCompetitorsByChannel(this.getCompetitors(), "instagram");
            this.handleCollectionChange();
        },

        selectLinkedInCompetitors: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;

            this.filterCompetitorsByChannel(this.getCompetitors(), "linkedin");
            this.handleCollectionChange();
        },

        selectTikTokCompetitors: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;

            this.filterCompetitorsByChannel(this.getCompetitors(), "tiktok");
            this.handleCollectionChange();
        },

        selectYouTubeCompetitors: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;

            this.filterCompetitorsByChannel(this.getCompetitors(), "youtube");
            this.handleCollectionChange();
        },

        selectTwitterCompetitors: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;

            this.filterCompetitorsByChannel(this.getCompetitors(), "twitter");
            this.handleCollectionChange();
        },

        selectFacebookOwnProfiles: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;

            this.filterCompetitorsByChannel(this.getOwnProfiles(), "facebook");
            this.handleCollectionChange();
        },

        selectInstagramOwnProfiles: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;

            this.filterCompetitorsByChannel(this.getOwnProfiles(), "instagram");
            this.handleCollectionChange();
        },

        selectLinkedInOwnProfiles: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;

            this.filterCompetitorsByChannel(this.getOwnProfiles(), "linkedin");
            this.handleCollectionChange();
        },

        selectTikTokOwnProfiles: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;

            this.filterCompetitorsByChannel(this.getOwnProfiles(), "tiktok");
            this.handleCollectionChange();
        },

        selectYouTubeOwnProfiles: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;

            this.filterCompetitorsByChannel(this.getOwnProfiles(), "youtube");
            this.handleCollectionChange();
        },

        selectTwitterOwnProfiles: function(ev) {
            ev.preventDefault();
            if (this.model.get('onlyOne') || $(ev.target).hasClass('disabled')) return;

            this.filterCompetitorsByChannel(this.getOwnProfiles(), "twitter");
            this.handleCollectionChange();
        },

        /**
         * Returns a list of competitor profiles that beansprout has collected competitor metrics for, not just competitors.
         */
        getCompetitors: function() {
            const competitorProfiles = VuexStore.getters["competitorProfiles/getCompetitorProfiles"];
            return  competitorProfiles;
        },

        /**
         * Returns a list of competitor profiles that beansprout has collected competitor metrics for, not just competitors.
         */
        getOwnProfiles: function() {
            const competitorProfiles = VuexStore.getters["competitorProfiles/getOwnProfiles"];
            return  competitorProfiles;
        },

        /**
         *
         * @param competitorProfiles this is actually just a list of profiles that beansprout has collected competitor metrics for.
         * @param channel eg. facebook, instagram, linkedin, tiktok, etc.
         */
        filterCompetitorsByChannel: function(competitorProfiles, channel) {
            // deselect all profiles from other channels
            _(this.list.collection.models).each(function (m) {
                if (!m.attributes.type.toLowerCase().includes(channel.toLowerCase())) {
                    m.setSelected(false);
                }
            });

            _(this.list.collection.models).each(function (m) {
                if (competitorProfiles.find(cp => cp.type.toLowerCase().includes(channel) && cp.brandId === m.id)) {
                    if (m.isSelected()) {
                        m.setSelected(false);
                    } else {
                        m.setSelected(true);
                    }
                }
            });

            this.handleCollectionChange();
        },

        handleCollectionChange: function() {
            var ids = _(this.list.collection.models).chain().filter(function(m) { return m.isSelected(); }).pluck('id').value();

            if (this.model.get('onlyOne')) {
                if (ids.length > 1) {
                    var currentId = this.previousId || 0;
                    ids = [ _(ids).find(function(d) { return d != currentId }) ];

                    _(this.list.collection.models).each(function (m) {
                        m.setSelected(m.id == ids[0]);
                    });
                }

                this.previousId = ids.length ? ids[0] : 0;
            }

            this.trigger('change', ids);
        },

        onRender: function() {
            var collection = new Beef.OnlineProfileList.Collection(null, {
                accountCode: currentAccountCode(),
                skipMeasurements: true
            });

            if (this.model.get('onlyOne')) {
                this.$('.actions .btn').toggleClass('disabled', true);
            }

            this.listenTo(collection, 'sync', this.updateSelected, this);
            this.listenTo(collection, 'reset', this.updateSelected, this);
            this.listenTo(collection, 'add', this.updateSelected, this);
            this.listenTo(collection, 'change:selected', this.handleCollectionChange, this);

            this.list =  new Beef.OnlineProfileList.View({collection: collection, display: 'short', select: true});
            this.listRegion.show(this.list);

            if (this.options.profiles) {
                collection.reset(this.options.profiles);
            }
            else {
                this.list.fetch();
            }
        },

        updateSelected: function() {
            if (!this.list) return;

            var list = this.list;
            var profileAttribute = this.model.get('profiles');

            if (profileAttribute) {
                var selected = _(splitUnique(profileAttribute)).map(function (val) { return parseInt(val); });

                setTimeout(function() {
                    _(list.collection.models).each(function (m) {
                        m.setSelected(_(selected).contains(m.id));
                    });
                })
            }
        },

        /** Values can be an array or space separated string. */
        setSelection: function(values) {
            this.model.set('profiles', values);
            this.updateSelected();
        },

        /** Get selected values as an array. */
        getSelection: function() {
            return _(this.list.collection.models).chain().filter(function(m) { return m.selected; }).pluck('id').value();
        }
    });

    this.createConverterFactory = function(placeholder) {
        return function(view) {
            var conv;
            return function(direction, value) {
                value = value? value.toString() : null;
                if (value && value.length > 0) {
                    var binding = this;
                    if (conv) {
                        return conv.call(binding, direction, value);
                    }
                    deprecatedFetchProfiles(view, function(profiles) {
                        conv = createTagConverter({
                            tooltip: function(code) {
                                var value = profiles.map[code];
                                var name = getProfileDisplayName(value.handle, value.handleId, value.name, value.type);
                                var network = Beef.Conversation.getNameOfNetwork(value, null);
                                return "The online profile, '" + value.name + "' (" + name + ")" + (network ? (", on " + network) : "");
                            },
                            items: profiles.map,
                            nameFormatter: function(value, isNeg) {
                                var prefix = (isNeg ? "-" : "") + getProfileIcon(value.type);
                                var name = getProfileDisplayName(value.handle, value.handleId, value.name, value.type);
                                return prefix + name;
                            },
                            placeholder: placeholder
                        });
                        return conv.call(binding, direction, value);
                    });
                } else {
                    if (placeholder) $(this.boundEls[0]).html(toPlaceholderHTML(placeholder));
                    else $(this.boundEls[0]).text("");
                }
                return value;
            }
        };
    };

    this.converterFactory = this.createConverterFactory(null);

    /**
     * Attach a profile picker to a view attribute identified by selector. Updates attribute in the view's model.
     *
     * Supported options
     * <ul>
     *     <li>onlyOne - allow only one profile to be chosen.
     *     <li>profiles - A list of profiles that should be shown instead of showing all available profiles.
     *     <li>title - The title to use, apart from the default.
     *     <li>disabled - An object with boolean properties 'all', 'facebookAll', 'instagramAll', 'twitterAll'.
     *                    If true, the 'select all' buttons for these profile types will be disabled. By default,
     *                    all buttons are enabled (i.e. set to false).
     */
    this.attach = function(view, selector, attribute, options) {
        options = Object.assign({
            disabled: {
                all: false,
                facebookAll: false,
                instagramAll: false,
                twitterAll: false
            },
            title: "Include statistics for these profiles"
        }, options || {});
        Beef.Picker.attachPicker(view, selector, attribute, this.View, options);
    };

});
